// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selectedSubCategories[data-v-21ef9bf5]{margin-bottom:1.6rem;padding-top:1rem}.selectedSubCategories__content[data-v-21ef9bf5]{padding:2rem}.selectedSubCategories--disableWhiteBackground .selectedSubCategories__content[data-v-21ef9bf5]{padding:2rem 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
